export default __webpack_public_path__ + "static/media/img4.26b69ac4.jpg";